import { Signal, TypedSignal } from "@/data/util/Signal";

import type { IPaymentReceiptControllerTransitionData } from "@/app/controller/PaymentReceiptController";
import type { IReceiptControllerTransitionData } from "@/app/controller/ReceiptController";

export const appEvents = {
    OnShowProfile: new Signal(),
    OnShowCreditCards: new Signal(),
    OnShowOrderHistory: new Signal(),
    OnShowHelp: new Signal(),
    OnShowPaymentHistory: new Signal(),
    OnShowOpenBills: new Signal(),
    OnSidenavVisibilityChanged: new Signal(),
    OnShowPaymentMethodReport: new Signal(),
    OnShowReceipt: new TypedSignal<IReceiptControllerTransitionData>(),
    OnShowPaymentReceipt: new TypedSignal<IPaymentReceiptControllerTransitionData>(),
};

export const config = {
    defaultTip: 0.05,
    maxTip: 0.2,
    // the kiosk asks whether the order should go on after this much inactivity, and resets
    // the session for the next customer if nobody answers within the second one
    kioskInactivityMs: 30000,
    kioskInactivityPopupMs: 30000,
    minPasswordLength: 6,
    minNameLength: 2,
    maxNameLength: 60,
    minCityLength: 2,
    showLoadingLabels: false,
    fulfillmentOrangeTimeTreshold: 180000,
    fulfillmentOrangePositionThreshold: 3,
};

export const features = {
    vueCartController: true,
};
